/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import ClientNavigation from './client/ClientNavigation';
import ContractorNavigation from './contractor/ContractorNavigation';

export default function NavigationContainer() {
    return (
            <Routes>
                <Route path='client/*' element={<ClientNavigation/>} />
                <Route path='contractor/*' element={<ContractorNavigation/>} />
                <Route path="*" element={<Navigate to={`contractor`} replace />} />
            </Routes>
    );
}
